export const toggleMobileNavBar = (state, action) => {
  state.mobileNavbarOpen = state.mobileNavbarOpen ? false : true;
};
